(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('PolicyTemplateController', PolicyTemplateController);

  /* ngInject */
  function PolicyTemplateController($document, $stateParams, policyTemplateService, sessionService) {

    const vm = this;

    vm.policyTemplate = {};

    activate();

    function activate() {
      getPolicyTemplate();
    }

    function getPolicyTemplate() {
      policyTemplateService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => vm.policyTemplate = response);
    }

  }
})();
